/* Utils */
import Subscription from '../../utils/Subscription';

type CursorVisibilitySubscriber = (newCursorVisibility: boolean) => void;

let cursorVisibility: boolean = false;
const cursorVisibilitySubscription = Subscription<boolean>();

export function getCursorVisibility(): boolean {
  return cursorVisibility;
}

export function setCursorVisibility(newCursorVisibility: boolean) {
  if (cursorVisibility !== newCursorVisibility) {
    cursorVisibility = newCursorVisibility;
    cursorVisibilitySubscription.notifySubscribers(cursorVisibility);
  }
}

export function toggleCursorVisibility() {
  setCursorVisibility(!cursorVisibility);
}

export function addCursorVisibilitySubscriber(subscriber: CursorVisibilitySubscriber) {
  cursorVisibilitySubscription.addSubscriber(subscriber);
}

export function removeCursorVisibilitySubscriber(subscriber: CursorVisibilitySubscriber) {
  cursorVisibilitySubscription.removeSubscriber(subscriber);
}
